import { render, staticRenderFns } from "./Succeed.vue?vue&type=template&id=e4f65212&scoped=true&"
import script from "./Succeed.vue?vue&type=script&lang=js&"
export * from "./Succeed.vue?vue&type=script&lang=js&"
import style0 from "./Succeed.vue?vue&type=style&index=0&id=e4f65212&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f65212",
  null
  
)

export default component.exports